import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { environment } from '@environments/environment';
import { ApiResponse } from '@app/_models';
import { RateSeasonSummary } from './rate-season-summary';
import { retry, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { AlertService } from '@app/_services';
import { SharedService } from '@app/_components/_shared/shared.service';

@Injectable({ providedIn: 'root' })
export class RateSeasonSummaryService
{
	constructor
		(
			private http: HttpClient,
			private alertService: AlertService,
			private sharedService: SharedService
		) { }

	urlEndpoint = 'rate-summaries';

	searchRateSummaries(rateSummary: RateSeasonSummary): Observable<ApiResponse>
	{
		console.log('posting... ' + JSON.stringify(rateSummary));
		return this.http.post<ApiResponse>(`${environment.yieldMaxApiUrl}/rateSeasons/summary`, rateSummary).pipe();
	}

	updateRateSummary(rateSummary: RateSeasonSummary): Observable<ApiResponse>
	{
		console.log('posting... ' + JSON.stringify(rateSummary));
		return this.http.patch<ApiResponse>(`${environment.yieldMaxApiUrl}/rateSeasons/summary`, rateSummary).pipe();
	}

}
